"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareAddDynamicColumnRequest = void 0;
function prepareAddDynamicColumnRequest(data, context, edit = false) {
    const request = {
        entity: data.entity,
        name: data.name,
        type: data.type,
        dataPath: data.dataPath,
        metadata: {
            columnHandlerName: data.metadata.columnHandlerName,
            label: data.metadata.label,
            showInFilters: data.metadata.showInFilters,
            showInTable: data.metadata.showInTable,
        },
    };
    if (!edit) {
        const columnHandler = context.columnHandlers.find((h) => h.name === data.metadata.columnHandlerName);
        request.type = data.multipleValues ? columnHandler === null || columnHandler === void 0 ? void 0 : columnHandler.arrayColumnType : columnHandler === null || columnHandler === void 0 ? void 0 : columnHandler.columnType;
    }
    return request;
}
exports.prepareAddDynamicColumnRequest = prepareAddDynamicColumnRequest;
